<template>
  <div class="home">
    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 fluid>
      <v-row class="mb-12">
        <v-col cols="12" id="imprintContent">
          <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Impressum</h1>

          <h2>Angaben gemäß § 5 TMG</h2>

          <h2>Sitz & Register</h2>
          <p>Die finCraft AG ist eine Aktiengesellschaft deutschen Rechts mit Hauptsitz in Bad
            Homburg v. d. Höhe. Sie ist im Handelsregister des Amtsgerichts Bad Homburg unter der Nummer HRB 15701
            eingetragen.
          </p>
          <p>Vorstand: Dr. Stefan Steib (Vorsitzender), Wolfram Hepp, Marcus Weinrich<br />
            Aufsichtsrat: Prof. Dr. Rainer Lorz (Vorsitzender), Konrad Hepp, Prof. Dr. Stefan Hencke, Gustav Egger, Andreas Bittner
          </p>

          <h2>Die Adresse der Gesellschaft lautet</h2>
          <p>
            finCraft AG <br/>
            Gartenstraße 27 <br/>
            D-61352 Bad Homburg, Deutschland
          </p>

          <h2>Design</h2>
          <p>Strichpunkt Agentur für visuelle Kommunikation GmbH</p>

          <h2>Konzept & Produktion</h2>
          <p>finCraft AG</p>

          <h2>Kontakt</h2>
          <p>Telefon: +49 6172 662621 822</p>
          <p>E-mail: <a href="mailto:info@fincraft.de">info@fincraft.de</a></p>

          <h2>Umsatzsteuer-ID</h2>
          <p>
            Die Mehrwertsteuer-Identifizierungsnummer der finCraft AG, Bad Homburg v. d. Höhe, (gemäß Artikel
            22 (1) der Sechsten Richtlinie 77/388/EWG vom 17. Mai 1977 zur Harmonisierung der Rechtsvorschriften der
            Mitgliedstaaten der Europäischen Gemeinschaft über die Umsatzsteuer) lautet: DE317057837
          </p>
          <p class="block-paragraph">
            Anregungen zur Gestaltung oder Fragen zum Inhalt dieser Webseiten senden Sie bitte an:
            <a href="mailto:info@fincraft.de">info@fincraft.de</a>
          </p>
          <p class="block-paragraph">
            &copy; finCraft AG, Bad Homburg v. d. Höhe. Alle Rechte vorbehalten.
          </p>

          <h2>Kurs- & Börsendaten</h2>
          <p>
            Infront -
            <a href="https://www.vwd.com/infront/" target="_blank">
              www.vwd.com/infront
              <v-img :src="require('@/assets/impressum/infront_logo.jpg')"
                     contain
                     width="225"/>
            </a>
          </p>

          <p class="block-paragraph">
            Factset -
            <a href="https://www.factset.com/" target="_blank">
              www.factset.com
              <v-img :src="require('@/assets/impressum/factset_logo.png')"
                     contain
                     width="225"/>
            </a>
          </p>

          <p class="block-paragraph">
            Tradegate -
            <a href="https://www.tradegate.de/" target="_blank">
              www.tradegate.de
              <v-img :src="require('@/assets/impressum/tradegate_logo.png')"
                     contain
                     width="320"/>
            </a>
          </p>

          <p class="block-paragraph">
            Citibank -
            <a href="https://www.citigroup.com/citi/" target="_blank">
              www.citigroup.com/citi
              <v-img :src="require('@/assets/impressum/citi_logo.png')"
                     contain
                     height="45"
                     width="69"/>
            </a>
          </p>

          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr" target="_blank">https://ec.europa.eu/consumers/odr</a>.
          </p>
          <p>
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>

          <h2>Verbraucherstreitbeilegung/
            <wbr>
            Universalschlichtungsstelle
          </h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2>Datenschutz</h2>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
            personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
            <router-link :to="{name: dataProtectionRouterName}" tag="span" class="text-decoration-underline">
              Datenschutzerklärung
            </router-link>
            .
          </p>
          <p>
            Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren
            Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt
            dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung
            nicht an Dritte weitergegeben.
          </p>
          <p>
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
            Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
            möglich.
          </p>
          <p>
            Datenschutzbeauftragter: <br />
            Dr. iur. Christian Borchers<br/>
            Datenschutz Süd GmbH<br/>
            Wörthstraße 15<br/>
            97082 Würzburg<br/>
            E-Mail: <a href="mailto:office@datenschutz-sued.de">office@datenschutz-sued.de</a>
          </p>

          <h2>Urheberrecht/Copyright</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>

          <h2>Cookies</h2>
          <p>
            Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden
            an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer
            zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser
            speichert.
          </p>
          <p>
            Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres
            Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen.
            Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
          </p>
          <p>
            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies
            nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das
            automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies
            kann die Funktionalität dieser Website eingeschränkt sein.
          </p>

          <h2>Server-Log-Files</h2>
          <p>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die
            Ihr Browser automatisch an uns übermittelt. Dies sind:
          </p>
          <ul>
            <li> Browsertyp und Browserversion</li>
            <li> verwendetes Betriebssystem</li>
            <li> Referrer URL</li>
            <li> Hostname des zugreifenden Rechners</li>
            <li> Uhrzeit der Serveranfrage</li>
          </ul>
          <p>
            Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen
            Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns
            konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.
          </p>

          <h2>Kontaktformular</h2>
          <p>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
            inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
            Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>

          <h2>SSL-Verschlüsselung</h2>
          <p>Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
            Beispiel der Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-Verschlüsselung. Eine
            verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://"
            wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
          <p>
            Wenn die SSL Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten
            mitgelesen werden.
          </p>

          <h2>Google Analytics</h2>
          <p>Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600
            Amphitheatre Parkway Mountain View, CA 94043, USA.
          </p>
          <p>
            Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert
            werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten
            Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
            übertragen und dort gespeichert.
          </p>

          <h2>IP Anonymisierung</h2>
          <p>Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von
            Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens
            über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt. <br>
            Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort
            gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung
            der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der
            Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu
            erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit
            anderen Daten von Google zusammengeführt.
          </p>

          <h2>Browser Plugin</h2>
          <p>
            Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software
            verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
            Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der
            durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an
            Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link
            verfügbare Browser-Plugin herunterladen und installieren: <br>
            <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">https://tools.google.com/dlpage/gaoptout?hl=de</a>
          </p>

          <h2>Widerspruch gegen Datenerfassung</h2>
          <p>
            Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link
            klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zukünftigen Besuchen dieser
            Website verhindert: Google Analytics deaktivieren
          </p>

          <h2>Auftragsdatenverarbeitung</h2>
          <p>
            Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen
            Vorgaben der deutschen Datenschutzbehörden bei der Nutzung von Google Analytics vollständig um.
          </p>
          <p>
            Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung
            von Google: <a href="https://support.google.com/analytics/answer/6004245?hl=de" target="_blank">https://support.google.com/analytics/answer/6004245?hl=de</a>
          </p>

          <h2>Recht auf Auskunft, Löschung, Sperrung</h2>
          <p>
            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten,
            deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung
            oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich
            jederzeit unter der im Impressum angegebenen Adresse an uns wenden.
          </p>
          <p>
            Quellenangabe: <a href="https://www.e-recht24.de" target="_blank">https://www.e-recht24.de</a>
          </p>


          <h2>Hinweis auf Finanzdienstleistungen</h2>
          <p>Wir bieten Ihnen als vertraglich gebundener Vermittler nach § 3 Abs. 2 des Wertpapierinstitutsgesetzes
            („WpIG“) im Namen sowie für Rechnung und unter der Haftung der BfV Bank für Vermögen AG - Hohemarkstraße 22,
            61440 Oberursel - folgende Finanzdienstleistungen an:
          </p>
          <ul>
            <li>Anlageberatung gem. § 2 Abs. 2 Nr. 4 WpIG</li>
            <li>Anlagevermittlung gem. § 2 Abs. 2 Nr. 3 WpIG</li>
          </ul>
          <p>Ihr künftiger Vertragspartner, die BfV Bank für Vermögen AG, verfügt über entsprechende Erlaubnisse der
            Bundesanstalt für Finanzdienstleistungsaufsicht.
          </p>

          <h2>Verweis auf Nachhaltigkeitsstrategie</h2>
          <p>Genauere Informationen zur Verordnung (EU) 2019/2088 des Europäischen Parlaments und des Rates vom 27.
            November 2019 über nachhaltigkeitsbezogene Offenlegungspflichten im Finanzdienstleistungssektor
            (Offenlegungsverordnung) finden Sie auf der Website unseres Haftungsdaches BfV Bank für Vermögen AG unter:
            <a href="https://bfv-ag.de/nachhaltigkeit/" target="_blank">https://bfv-ag.de/nachhaltigkeit/</a>.
          </p>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  data() {
    return {
      dataProtectionRouterName: ''
    }
  },
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.$route.name === 'imprintProtected') {
      this.dataProtectionRouterName = 'dataProtectionProtected'
    } else {
      this.dataProtectionRouterName = 'finDataProtection'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles/variables.scss";
@import "./../../styles/home.scss";

.home {

  h1 {
    color: $fin-color-primary-dark !important;
  }

  h2 {
    color: $fin-color-primary-dark !important;
    margin: 40px 0 6px 0;
    font-size: 32px;
  }

  p {
    color: $fin-color-primary-dark !important;
    margin: 12px 0 6px 0;

    &.block-paragraph {
      margin-top: 30px;
    }
  }

  .container {
    padding: 32px 45px 32px 32px;
  }

  .col {
    padding-top: 0;
  }

  /* Definition for mobile (375px) - vuetify breakpoint for xs */

  @media only screen and (max-width: 600px) {

    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
    }

  }
}

</style>
